import 'swiper/css/effect-fade';
import { A11y, EffectFade, Keyboard, Navigation } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { NavigationButtons, SwiperCarousel } from 'components/rebrand/SwiperCarousel';
import { H3 } from 'components/rebrand/Typography';

import { ISanityContentCard } from 'typescriptDefs';

type Props = {
  label: string;
  testimonials: ISanityContentCard[];
};

const Testimonials = ({ label, testimonials }: Props) => {
  const nextClass = 'home-testimonials-next';
  const prevClass = 'home-testimonials-prev';

  return (
    <Section className="py-56 md:py-80">
      <Container className="px-32 xs:px-0">
        <SwiperCarousel
          noNavigation
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 16 },
          }}
          slidesOffsetAfter={0}
          nextNavEl={nextClass}
          prevNavEl={prevClass}
          modules={[A11y, Keyboard, Navigation, EffectFade]}
          effect="fade"
          fadeEffect={{ crossFade: true }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="rounded-16 bg-primary-400 p-32 text-white">
                <div className="flex flex-col">
                  <div>
                    <H3 className="mb-32 text-3xl leading-90 text-primary-75 md:mb-48 md:text-3xl">{label}</H3>
                    <div className="mb-48 md:w-[80%] [&_p]:text-4xl [&_p]:font-bold [&_p]:leading-tight md:[&_p]:text-[36px] md:[&_p]:leading-none">
                      <CustomPortableText content={testimonial.heading} />
                    </div>
                    <div className="[&>*]:leading-gripped">
                      <CustomPortableText content={testimonial.description} />
                    </div>
                  </div>
                  <NavigationButtons
                    className="mt-auto pt-24 md:self-end [&_button]:h-44 [&_button]:w-44"
                    nextNavEl={nextClass}
                    prevNavEl={prevClass}
                    buttonVariant="primaryBright"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      </Container>
    </Section>
  );
};

export default Testimonials;
